var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"col-md-12",staticStyle:{"display":"contents"}},[_c('pending-offers-table',{attrs:{"data":_vm.offers,"loaded":_vm.loaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }